import { LoadStatus, TimezoneDate } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { makeObservable, observable, runInAction } from 'mobx';
import { DashboardApi, DashboardInfo } from '../api';
import { DashboardCustomerAddressesStore } from './dashboard-customer-addresses.store';
import { DashboardInvoicesStore } from './dashboard-invoices.store';

/* we fill info with empty data to show skeletons wile first load */
const defaultInfo = (): DashboardInfo => {
    const dt = TimezoneDate.dateFromDateLocal(new Date());
    const text = '000000';
    const idn = { name: 'text', id: 0, address: { street: text, city: text } };

    return {
        customerInvoices: [],

        visits: ['1', '2', '3'].map(id => ({
            id,
            name: text,
            status: 0,
            location: idn,
            isAllLocations: false,
            isRenewed: false,
            visitDue: false,
            from: dt,
            to: dt,
            nextBillingDate: dt,
        })),
        appointments: [1, 2, 3].map(id => ({
            id,
            number: text,
            status: 0,
            startDate: dt,
            endDate: dt,
            jobType: idn,
            location: idn,
        })),
        proposals: [],
    };
};
@injectable()
export class DashboardStore {
    @observable loadStatus = LoadStatus.Loading;
    @observable data = defaultInfo();

    constructor(
        @inject(DashboardApi) private dashboardApi: DashboardApi,
        @inject(DashboardCustomerAddressesStore)
        private dashboardCustomerAddressesStore: DashboardCustomerAddressesStore,
        @inject(DashboardInvoicesStore) private dashboardInvoicesStore: DashboardInvoicesStore
    ) {
        makeObservable(this);

        this.loadData([]);
    }

    onLocationsChanged = () => {
        const selectedLocationIds = this.dashboardCustomerAddressesStore.getSelectedAddress();
        this.loadData(selectedLocationIds);
        this.dashboardInvoicesStore.loadInvoices(selectedLocationIds);
    };

    private async loadData(selectedLocationIds: number[]) {
        runInAction(() => (this.loadStatus = LoadStatus.Loading));

        try {
            const data = await this.dashboardApi.getDashboardData(selectedLocationIds);

            runInAction(() => {
                this.loadStatus = LoadStatus.Ok;
                this.data = data;
            });
        } catch {
            runInAction(() => (this.loadStatus = LoadStatus.Error));
        }
    }
}
